/* unplugin-vue-components disabled */import script from "./SectionContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./SectionContainer.vue?vue&type=script&setup=true&lang=ts"

import "./SectionContainer.vue?vue&type=style&index=0&id=85abab60&scoped=true&lang=scss"

import exportComponent from "/root/.jenkins/workspace/高保障-门户广西-前端页面-saas/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85abab60"]])

export default __exports__